module.exports = __webpack_public_path__ + "static/media/team2.1a507aef.jpg";